import AddressDetail from './address-detail.vue'
export default {
  'address-detail': AddressDetail
}